import { useNavigate, useParams } from "react-router"
import { useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Spinner } from "@phosphor-icons/react"
import { Button } from "@repo/ui"
import { useVerifyQuery } from "@/feature/auth/api"
import { useStep } from "@/lib/hooks/useStep"
import { WizardSuccessScreen } from "@/components/shared/WizardSuccessScreen"
import { LogoExtended } from "@/routes/layouts/public-layout"
import WarningIcon from "./assets/Warning.svg"

export const ConfirmScreen = () => {
  const { token } = useParams<{ token: string }>()
  const { isSuccess, isError } = useVerifyQuery(token!)
  const [, actions] = useStep(2)
  const navigate = useNavigate()
  const goToDashboard = useCallback(() => navigate(`/`), [navigate])
  const lastItemUtils = useMemo(
    () => ({ ...actions, goToNextStep: goToDashboard }),
    [goToDashboard, actions]
  )
  const { t } = useTranslation(`wizard`)
  const { t: commonT } = useTranslation(`common`)

  if (isSuccess) {
    return (
      <div className="bg-white w-full p-8 h-full">
        <WizardSuccessScreen actions={lastItemUtils}>
          <div>
            <h1 className="text-4xl text-center font-medium">
              {t(`sign_up.screens.confirm.success.title`)}
            </h1>
            <p className="text-muted-foreground mt-1 text-center">
              {t(`sign_up.screens.confirm.success.description`)}
            </p>
          </div>
        </WizardSuccessScreen>
      </div>
    )
  }
  if (isError) {
    return (
      <div className="bg-white w-full p-8 h-full flex flex-col items-center justify-between">
        <LogoExtended />
        <div className="max-w-md">
          <div className="flex flex-col items-center justify-between gap-8">
            <h1 className="text-4xl text-center font-medium">
              {t(`sign_up.screens.confirm.error.title`)}
            </h1>
            <img
              src={WarningIcon}
              alt="Warning icon"
              width={156}
              height={157}
            />

            <p className="text-muted-foreground mt-1 text-center">
              {t(`sign_up.screens.confirm.error.description`)}
            </p>
          </div>
        </div>
        <Button onClick={() => navigate(`/auth/login`)}>
          {commonT(`button.login`)}
        </Button>
      </div>
    )
  }
  return (
    <div className="bg-white w-full p-8 h-full flex flex-col items-center justify-center">
      <Spinner className="w-10 h-10 animate-spin" />
    </div>
  )
}
